import mitt from 'mitt'

export default defineNuxtPlugin(() => {
  const emitter = mitt()

  return {
    provide: {
      emitPublicEvent: emitter.emit, // Will emit an event
      onPublicEvent: emitter.on // Will register a listener for an event
    }
  }
})
